/**
 * Updates delivery timeline dates based on data attributes on each root element.
 */
function getOrdinalSuffix(day) {
  if (day > 3 && day < 21) return 'th';
  switch (day % 10) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
}

const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

function formatDateWithOrdinal(date) {
  const month = MONTHS[date.getMonth()];
  const day = date.getDate();
  return `${month} ${day}${getOrdinalSuffix(day)}`;
}

function addDays(date, days) {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}

function initDeliveryTimeline(root) {
  const prepMin = parseInt(root.dataset.prepMin, 10) || 6;
  const prepMax = parseInt(root.dataset.prepMax, 10) || 7;
  const deliveryMin = parseInt(root.dataset.deliveryMin, 10) || 9;
  const deliveryMax = parseInt(root.dataset.deliveryMax, 10) || 14;
  const today = new Date();

  const minShipStart = addDays(today, prepMin);
  const maxShipStart = addDays(today, prepMax);
  const minDeliverDay = addDays(today, deliveryMin);
  const maxDeliverDay = addDays(today, deliveryMax);

  const setText = (selector, text) => {
    root.querySelectorAll(selector).forEach((el) => {
      el.textContent = text;
    });
  };

  setText('[data-delivery-min]', formatDateWithOrdinal(minDeliverDay));
  setText('[data-delivery-max]', formatDateWithOrdinal(maxDeliverDay));
  setText('[data-ship-min]', formatDateWithOrdinal(minShipStart));
  setText('[data-ship-max]', formatDateWithOrdinal(maxShipStart));
}

function initAllDeliveryTimelines() {
  document.querySelectorAll('[data-delivery-timeline]').forEach(initDeliveryTimeline);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllDeliveryTimelines);
} else {
  initAllDeliveryTimelines();
}

document.addEventListener('shopify:section:load', initAllDeliveryTimelines);
